import React from "react";
import Navbar from "./Navbar";
import SidebarComponent from "./Sidebar";
import NewTicketAlert from "./NewTicketAlert";

function Layout() {
  // Task sheet issues are only ever assigned to MANAGER users
  const isManager =
    Boolean(localStorage.getItem("authorization")) &&
    localStorage.getItem("roles") === "MANAGER";

  return (
    <>
      <Navbar />
      <SidebarComponent />
      {isManager && <NewTicketAlert />}
    </>
  );
}

export default Layout;
